<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName">
      <h3>
        <i class="fa fa-fw fa-qrcode"></i> {{ _('Ticket reader') }}
      </h3>
      <p>{{ _('Scan ticket QR codes to confirm seats for the selected events or resources.') }}</p>
      <p><a :href="'/' + shopId + '/reader'">{{ _('Open full-screen ticket reader') }}</a></p>
      <client-only>
        <TicketReaderCore layout="column" />
      </client-only>
    </div>
  </div>
</template>

<script>
import components from '~/lib/components'
import TicketReaderCore from '~/components/ticket-reader/TicketReaderCore.vue'

export default {
  components: { TicketReaderCore },
  mixins: [components]
}
</script>
